import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import {
  AlertController,
  ModalController,
  LoadingController,
  PopoverController,
} from '@ionic/angular';
import { LineitemConfiguratorPage } from './lineitem-configurator/lineitem-configurator.page';
import { UserService } from '../../services/user.service';
import { SaleService, SALE_CHECKOUT_TYPE } from '../../services/sale.service';
import { SalonService } from '../../services/salon.service';
import { Stylist } from '../../models/stylist/stylist.model';
import { Client } from '../../models/client/client.model';
import { Service } from '../../models/service/service.model';
import { Lineitem } from '../../models/line-item/line-item.model';
import { Product } from '../../models/product/product.model';
import { Sale } from '../../models/sale/sale.model';
import { Payment } from '../../models/payment/payment.model';
import { CalendarCacheService } from '../../services/calendar-cache.service';
import { SquarePOSService } from '../../services/square-pos.service';
import { StripeService } from '../../services/stripe.service';
import { AlertService } from '../../utilities/alert.service';
import { SaleMoreOptionsPopoverPage } from '../sale-checkout/sale-more-options-popover/sale-more-options-popover.page';
import { SaleBookingPickerPage } from '../sales-shared/sale-booking-picker/sale-booking-picker.page';
import { SaleServicePickerPage } from '../sale-checkout/sale-service-picker/sale-service-picker.page';
import { SaleProductPickerPage } from '../sale-checkout/sale-product-picker/sale-product-picker.page';
import { DateRangeSelectorComponent } from '../../components/smr-date-picker/date-range-selector/date-range-selector.component';
import { Router, ActivatedRoute } from '@angular/router';

import { SaleRefundPickerComponent } from '../sales-shared/components/sale-refund-picker/sale-refund-picker.component';
import { SaleRefundCardConfirmationComponent } from '../sales-shared/components/sale-refund-card-confirmation/sale-refund-card-confirmation.component';
import { NavigationStateService } from '../../services/navigation-state.service';
declare var posthog: any;

export interface SaleCheckOutCallBackData {
  sale: Sale;
  action: string;
}

@Component({
  selector: 'app-sale-checkout',
  templateUrl: './sale-checkout.page.html',
  styleUrls: ['./sale-checkout.page.scss'],
})
export class SaleCheckoutPage implements OnInit, OnDestroy {
  public isLoading: boolean;

  public stylist: Stylist;

  @Input() sale: Sale;

  public saleRefundParent: Sale;

  @Input() isFromBookings: boolean = false;
  @Input() isFromRegisterClosure;

  public checkOutPromise: Function;

  public title: string;

  public readOnly: boolean;

  public timeOptions: Array<{ name: string; value: string }>;
  public lineItemDateTime: Date;

  public url: string;

  public isServiceDate: boolean = true;

  public navigationStateSubscription;

  constructor(
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private saleService: SaleService,
    private salonService: SalonService,
    private changeDetectorRef: ChangeDetectorRef,
    private calendarCacheService: CalendarCacheService,
    private userService: UserService,
    private popOverCtrl: PopoverController,
    private squarePOSService: SquarePOSService,
    private loadingCtrl: LoadingController,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private stripeService: StripeService,
    private navigationStateService: NavigationStateService
  ) {
    this.navigationStateSubscription = this.navigationStateService.getState().subscribe((state) => {
      this.sale = state.sale;
      this.isFromBookings = state.isFromBookings;
      this.isFromRegisterClosure = state.isFromRegisterClosure;
      this.timeOptions = this.calendarCacheService.getCachedTimeoptions();
      this.isLoading = false;
    });
  }

  public ngOnInit() {
    this.url = this.router.url;
    if (this.sale.isRefundSale()) {
      this.title = 'Refund Sale';
      this.saleService
        .loadSaleByID(this.sale.saleRefundParent)
        .subscribe((sale) => {
          this.saleRefundParent = sale;
        });
    } else {
      if (
        this.sale.getSaleEditParent() !== null &&
        this.sale.getSaleEditParent() !== undefined
      ) {
        this.title = 'Edit Sale';
        posthog.capture('Sale Reopend for Editing', {
          clientFirstName: this.sale.client.firstName,
          clientLastName: this.sale.client.lastName,
        });
      } else if (this.sale.status === 2 && this.sale.id) {
        this.title = 'On Hold';
        posthog.capture('Sale Resumed', {
          clientFirstName: this.sale.client.firstName,
          clientLastName: this.sale.client.lastName,
        });
      } else {
        this.title = 'New Sale';
        posthog.capture('Sale Created', {
          clientFirstName: this.sale.client.firstName,
          clientLastName: this.sale.client.lastName,
        });
      }
    }

    this.readOnly = this.userService.getSalon().readOnly === 1;

    let firstLineItem = this.sale.lineitems.first();
    if (firstLineItem) {
      this.lineItemDateTime = new Date(firstLineItem['startDateTime']);
      if (
        this.sale.datetime > this.lineItemDateTime &&
        !this.isSameDate(this.sale.datetime, this.lineItemDateTime)
      ) {
        this.isServiceDate = false;
      }
    }
  }

  public ngOnDestroy() {
    this.navigationStateSubscription.unsubscribe();
  }

  public isSameDate(date1, date2) {
    if (
      date1.getDate() == date2.getDate() &&
      date1.getMonth() == date2.getMonth() &&
      date1.getYear() == date2.getYear()
    )
      return true;
    return false;
  }

  public ionViewCanEnter() {
    if (!this.sale) {
      setTimeout(() => {
        this.router.navigateByUrl('/sale-manager');
      }, 100);
      return false;
    }

    return true;
  }

  public onTapToReload() {}

  public holdSale() {}

  public async changeDate() {
    const modal = await this.modalCtrl.create({
      component: DateRangeSelectorComponent,
      componentProps: {
        startDate: this.sale.getDateTime(),
        pickMode: 'single',
        showJumpCalendar: false,
      },
      cssClass: 'modal-bg',
    });

    modal.onDidDismiss().then((data: any) => {
      if (data.data) {
        this.sale = this.sale.setDateTime(data.data.date);
        this.changeDetectorRef.markForCheck();
      }
    });

    await modal.present();
  }

  changeToServiceDate() {
    this.sale = this.sale.setDateTime(this.lineItemDateTime);
    this.isServiceDate = true;
    this.changeDetectorRef.markForCheck();
  }

  public checkOutSale() {
    this.navigationStateService.setState({
      sale: this.sale,
      isFromBookings: this.isFromBookings,
      isFromRegisterClosure: this.isFromRegisterClosure,
    });
    this.router.navigate(['sales/sale-checkout/sale-payment']);
  }

  public showProductPicker(client: Client) {
    this.showLineitemPicker(client, 'product');
  }

  public showServicePicker(client: Client) {
    this.showLineitemPicker(client, 'service');
  }

  public async showLineitemPicker(client: Client, lineitemType: string) {
    let serviceLineItem: Lineitem = this.sale
      .getLineItems()
      .filter(
        (lineitem) =>
          lineitem.getType() === 'service' &&
          lineitem.getClient().getID() === client.getID()
      )
      .first();
    const modal = await this.modalCtrl.create({
      component:
        lineitemType === 'product'
          ? SaleProductPickerPage
          : SaleServicePickerPage,
      componentProps: {
        stylist: serviceLineItem ? serviceLineItem.stylist : undefined,
      },
      cssClass: 'modal-fullscreen',
    });
    modal.onWillDismiss().then((data: any) => {
      if (data.data) {
        let lineitem = data.data;
        this.salonService.getTaxes().subscribe({
          next: (salonTaxes) => {
            let retailPrice: number = 0;

            if (lineitem.type === 'product') {
              const product = <Product>lineitem;
              retailPrice = product.retail;
            } else {
              const service = <Service>lineitem;
              retailPrice = service.price;
            }

            lineitem = lineitem.setPrice(retailPrice);
            // lineitem = lineitem.setCustomTaxes(customTaxes);
            lineitem = lineitem.setClientID(client.id);
            lineitem = lineitem.setClient(client);

            this.sale = this.sale.addLineItem(lineitem);
            this.changeDetectorRef.markForCheck();
          },
          error: (e) => {
            this.alertService.presentErrorAlert();
          },
        });
      }
    });

    await modal.present();
  }

  public async addAppointment() {
    const modal = await this.modalCtrl.create({
      component: SaleBookingPickerPage,
      componentProps: { sale: this.sale },
      cssClass: 'modal-bg',
    });
    modal.onWillDismiss().then((data: any) => {
      if (data.data) {
        let booking = data.data;
        booking.services.forEach((service) => {
          service = service.setTaxRateType(0);
          this.sale = this.sale.addLineItem(service);
          this.changeDetectorRef.markForCheck();
        });
      }
    });
    await modal.present();
  }

  public async editLineitem(lineitem: Lineitem) {
    const modal = await this.modalCtrl.create({
      component: LineitemConfiguratorPage,
      componentProps: { lineitem: lineitem, sale: this.sale },
      cssClass: 'modal-bg',
    });
    modal.onWillDismiss().then((data: any) => {
      if (data.data) {
        if (data.data.action === 'save') {
          this.sale = this.sale.updateLineItem(data.data.lineitem);
        } else {
          // remove
          if (data.data.lineitem.type === 'product') {
            this.sale = this.sale.removeLineItem(data.data.lineitem);
          } else {
            const service = <Service>data.data.lineitem;
            this.sale = this.sale.removeLineItemsByBookingGroupID(
              service.bookingGroupID
            );
          }
        }

        this.changeDetectorRef.markForCheck();
      }
    });
    await modal.present();
  }

  public async showMoreOptions($event) {
    const popOver = await this.popOverCtrl.create({
      component: SaleMoreOptionsPopoverPage,
      componentProps: { sale: this.sale },
      event: $event,
    });

    popOver.onWillDismiss().then(async ($event) => {
      if ($event.data) {
        if ($event.data === 'onhold') {
          const loadingCtrl = await this.loadingCtrl.create({
            spinner: 'crescent',
          });
          loadingCtrl.present();

          this.sale = this.sale.setStatus(2);
          this.saleService.save(this.sale).subscribe({
            next: (sale) => {
              loadingCtrl.dismiss();
              this.sale = sale;

              if (this.isFromBookings) {
                this.router.navigateByUrl('/bookings');
              } else if (this.isFromRegisterClosure) {
                this.router.navigateByUrl(
                  `register-closures/${this.isFromRegisterClosure}`
                );
              } else {
                this.router.navigateByUrl('/sales');
              }
            },
            error: (e) => {
              loadingCtrl.dismiss();
              this.alertService.presentErrorAlert();
            },
          });
        }
        if ($event.data === 'cancel') {
          const loadingCtrl = await this.loadingCtrl.create({
            spinner: 'crescent',
          });
          loadingCtrl.present();

          this.saleService.cancel(this.sale).subscribe({
            next: () => {
              loadingCtrl.dismiss();
              this.router.navigateByUrl('/sales');
            },
            error: (e) => {
              loadingCtrl.dismiss();
              this.alertService.presentErrorAlert();
            },
          });
        }
      }
    });

    await popOver.present();
  }

  public onSaleUpdated(sale: Sale) {
    this.sale = sale;
    this.changeDetectorRef.markForCheck();
  }

  public close() {
    this.router.navigate([
      '/bookings/booking-form-summary/',
      (this.sale.lineitems.first() as Service).bookingGroupID,
    ]);
  }

  public async selectRefundMethod() {
    const modal = await this.modalCtrl.create({
      component: SaleRefundPickerComponent,
      componentProps: {
        saleRefundParent: this.saleRefundParent,
      },
    });

    modal.onWillDismiss().then(async (data) => {
      if (data.data) {
        if (data.data.refundType == 'card') {
          const cardInfo = data.data.cardInfo;
          const cardRefundModal = await this.modalCtrl.create({
            component: SaleRefundCardConfirmationComponent,
            componentProps: {
              amount: 0 - this.sale.total,
              cardInfo: cardInfo,
            },
          });

          cardRefundModal.onWillDismiss().then((data) => {
            if (data.data) {
              this.stripeService
                .refund({
                  paymentIntentID: cardInfo.intentID,
                  amount: Math.round((0 - this.sale.total) * 100),
                })
                .subscribe((res) => {
                  const payment: Payment = new Payment({
                    id: undefined,
                    name: '',
                    type: cardInfo.type,
                    amount: this.sale.total,
                  });

                  this.sale = this.sale.addPayment(payment);

                  this.completeSale();
                });
            }
          });
          cardRefundModal.present();
        }
        if (data.data.refundType == 'cash') {
          const payment: Payment = new Payment({
            id: undefined,
            name: '',
            type: 1,
            amount: this.sale.total,
          });

          this.sale = this.sale.addPayment(payment);

          this.completeSale();
        }
        if (data.data.refundType == 'external') {
          const payment: Payment = new Payment({
            id: undefined,
            name: '',
            type: 25,
            amount: this.sale.total,
          });

          this.sale = this.sale.addPayment(payment);

          this.completeSale();
        }
      }
    });

    modal.present();
  }

  public completeSale() {
    this.saleService.setSaleToBeCheckedOut(
      this.sale,
      SALE_CHECKOUT_TYPE.salonMonsterPay
    );

    this.navigationStateService.setState({
      sale: this.sale,
      isFromBookings: this.isFromBookings,
      isFromRegisterClosure: this.isFromRegisterClosure,
    });

    if (this.sale.isSaleReadyForCheckOut()) {
      this.router.navigate(['./sales/sale-checkout/sale-confirmation']);
    }
  }
}
